export class SubmittedFormsRequest {
  source: string | null;
  claimId: string | null;
  claimNumber: string | null;
  formType: string | null;
  vendorID: string | null;
  officeNum: string | null;
}
